<template>
    <ion-page>
        <SignedInHeader></SignedInHeader>
        <ion-content>
            <ion-grid>
                <ion-row>
                    <ion-col size-xs="12" offset-xs="0" size-sm="8" offset-sm="2" size-md="6" offset-md="3" size-lg="4" offset-lg="4" text-center>
                        <ion-card>
                            <ion-card-header>
                                <ion-card-title text-left color="primary">{{ $t('screens.profile.personal-info') }}</ion-card-title>
                            </ion-card-header>
                            <ion-card-content>
                                <ion-item class="input">
                                    <ion-input placeholder="first name" :value="getUserDetails(user).given_name" min="2" ref="given-name"></ion-input>
                                </ion-item>
                                <ion-item class="input">
                                    <ion-input placeholder="last name" :value="getUserDetails(user).family_name" min="2" ref="family-name"></ion-input>
                                </ion-item>
                                <ion-button @click="updateProfile()">{{ $t('screens.profile.update') }}</ion-button>
                            </ion-card-content>
                        </ion-card>
                        <!-- <ion-card>
                            <ion-card-header>
                                <ion-card-title text-left color="primary">Deal preferences</ion-card-title>
                            </ion-card-header>
                            <ion-card-content>
                                <ion-item lines="none">
                                    <ion-label>Prefer deals with accommodation</ion-label><ion-toggle></ion-toggle>
                                </ion-item>
                                <ion-item lines="none">
                                    <ion-label>Avoid budget hotels and hostels</ion-label><ion-toggle></ion-toggle>
                                </ion-item>
                            </ion-card-content>
                        </ion-card> -->
                        <ion-card>
                            <ion-card-header>
                                <ion-card-title text-left color="primary">{{ $t('screens.profile.feedback-support') }}</ion-card-title>
                            </ion-card-header>
                            <ion-card-content>
                                <ion-button @click="openSupportModal()"><ion-icon name="help-circle-outline" slot="start"></ion-icon>{{ $t('screens.profile.support') }}</ion-button>
                            </ion-card-content>
                        </ion-card>
                        <ion-card>
                            <ion-card-header>
                                <ion-card-title text-left color="primary">{{ $t('screens.profile.logout') }}</ion-card-title>
                            </ion-card-header>
                            <ion-card-content>
                                <ion-button @click="signOut()"><ion-icon name="log-out" mode="md" slot="start"></ion-icon>{{ $t('screens.profile.logout') }}</ion-button>
                            </ion-card-content>
                        </ion-card>
                    </ion-col>
                </ion-row>
            </ion-grid>
        </ion-content>
    </ion-page>
</template>

<script>
    import SignedInHeader from "@/components/SignedInHeader";
    import helpers from "@/helpers";
    import axios from 'axios';
    import Support from "@/components/Support";

export default {
    name: 'Profile',
    components: {
        SignedInHeader
    },
    data() {
        return {
            user: this.$store.state.user,
            alerts: [],
            supportModal: null
        };
    },
    methods: {
        getUserDetails: helpers.getUserDetails,
        signOut: async function() {
            try {
                const user = await this.$Amplify.Auth.currentAuthenticatedUser();
                const userDetails = await helpers.getUserDetails(user);

                await this.$Amplify.Auth.signOut();

                // if it's a federated login, there's a redirect on logout, so we don't trigger the signout signal
                // as it is not necessary
                if (!('identities' in userDetails)) {
                    this.$AmplifyEventBus.$emit('authState', 'signedOut');
                }
            } catch(err) {
                this.$logger.error('error', err);
            }
        },
        updateProfile: function() {
            this.$Amplify.Auth.currentAuthenticatedUser()
            .then(user => {
                this.$logger.debug('user', user);
                axios
                    .put(process.env.VUE_APP_API_FEED_BASE + '/profile',
                        {
                            headers: { Authorization: `Bearer ${this.user.signInUserSession.getIdToken().getJwtToken()}`},
                        }
                    ).then(response => {
                        this.$logger.debug(response);
                    })
                    .catch((err) => {
                        this.$logger.error('error', err);
                    });
            })
            .catch((error) => {
                this.$logger.error(error);
                if (error.response && error.response.status === 401 || error == 'not authenticated') {
                    this.$logger.debug('unauthorized');
                this.$router.push('/');
                }
                //this.$router.push('/welcome');
                this.$logger.debug('catch auth');
            });
        },
        openSupportModal: function() {
            return this.$ionic.modalController
                .create({
                    component: Support,
                    componentProps: {
                        parent: this
                    },
                    cssClass: "custom-support-modal"
                })
                .then(m => {
                    this.supportModal = m;
                    m.present();
                })
        },
        dismissModal: function() {
            if (this.supportModal) {
                this.supportModal.dismiss().then(() => { this.supportModal = null; });
            }
        },
    },
    mounted() {
        this.$Amplify.Auth.currentAuthenticatedUser().then(u=> {
            //const userinfo = await Auth.currentUserInfo();
            this.$logger.debug('U', u);
            /*store.setUser(u);
            this.user = u;
            this.getAlerts();*/
            this.$Amplify.Auth.currentUserInfo().then(res => {
                this.$logger.debug('Res', res);
            }).catch(err => {
                this.$logger.error(err);
            });
        });

        this.$on('dismissModal', () => {
            this.dismissModal();
        });

        this.$on('commitSupportRequest', (message) => {
            this.commitSupportRequest(message);
        });
    }
};
</script>
<style scoped>
ion-grid {
    padding: 0;
}

ion-content {
    --background: url('~@/assets/bg/bg10.jpg') no-repeat center center / cover;
}

ion-card-header {
    --background: none;
}

ion-card {
    --background: rgba(255,255,255,.8);
    font-family: 'Nunito', sans-serif;
    margin-bottom: 1em;
}

ion-card-title {
    font-size: 2em;
    font-weight: bold;
}

ion-list {
    background: none;
}

ion-item {
    --background: none;
    --color: #333;
}

ion-item.input {
    --background: rgba(255,255,255,.6);
    width: 98%;
    margin-left: 1%;
    margin-bottom: .5em;
}
</style>

<style>
    .custom-support-modal {
        padding: 3em;
        min-height: 16em;
        height: auto;
    }

    .custom-support-modal .modal-wrapper {
        min-height: 18em;
        border-radius: 4px;
        height: auto;
    }
</style>